export const convertRgbaToHex = (color) => {
  const { r, g, b, a } = color;

  // Convert opacity to hexadecimal and ensure it's a two-digit value
  const opacityHex = Math.max(0, Math.min(255, Math.round(a * 255)))
    .toString(16)
    .padStart(2, "0");

  return (
    "#" +
    ((1 << 24) + (parseInt(r) << 16) + (parseInt(g) << 8) + parseInt(b))
      .toString(16)
      .slice(1) +
    opacityHex
  );
};

export const convertHexToRgba = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: 1,
      }
    : null;
};
export const rgbaToString = (color) => {
  if (color) {
    return `rgba(${Object.keys(color)
      .map((i) => color[i])
      .join(",")})`;
  }
};
export const stringToRgba = (rgba) => {
  if (!rgba) return "";
  let colors = ["r", "g", "b", "a"];

  let colorArr = rgba
    .slice(rgba.indexOf("(") + 1, rgba.indexOf(")"))
    .split(",");

  let obj = new Object();

  colorArr.forEach((k, i) => {
    obj[colors[i]] = Number(k);
  });
  if (typeof obj.a === "undefined") {
    obj.a = 1; // Set alpha to 1 if it is not specified in the input
  }
  return obj;
};
export const getRgbaLighterShade = (color, amount) => {
  let { r, g, b } = stringToRgba(color);
  //return rgbaToString({r,g,b,a:a?a-0.1:})
  amount = amount === 0 ? 0 : amount || 10;
  r = Math.max(0, Math.min(255, r - Math.round(255 * -(amount / 100))));
  g = Math.max(0, Math.min(255, g - Math.round(255 * -(amount / 100))));
  b = Math.max(0, Math.min(255, b - Math.round(255 * -(amount / 100))));
  return rgbaToString({ r, g, b });
};

export const darken = (color, percentage) => {
  // Check if color is in RGBA format
  const isRgba = color.includes("rgba");

  // Extract color values
  const colorValues = isRgba
    ? color.match(/\d+(\.\d+)?/g)
    : color.match(/\d+/g);
  let [red, green, blue, alpha] = colorValues;

  // Darken color by percentage
  red = Math.round(red * (1 - percentage / 100));
  green = Math.round(green * (1 - percentage / 100));
  blue = Math.round(blue * (1 - percentage / 100));

  // Return the updated color
  if (isRgba) {
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  } else {
    return `rgb(${red}, ${green}, ${blue})`;
  }
};
export const lightenRGBColor = (color, percent) => {
  if (!color) {
    return;
  }
  // Remove any whitespace and convert to lowercase
  color = color.trim().toLowerCase();

  // Check if the color is in RGB or RGBA format
  const isRgb = color.startsWith("rgb");
  const isRgba = color.startsWith("rgba");

  if (!isRgb && !isRgba) {
    throw new Error("Invalid color format. Expected RGB or RGBA.");
  }

  // Extract the color channels
  const channels = color.match(/\d+/g).map(Number);

  // Calculate the lighten amount
  const lightenAmount = percent / 100;

  // Lighten each color channel
  const lightenedChannels = channels.map((channel) =>
    Math.round(channel + (255 - channel) * lightenAmount)
  );

  // Build the new color value
  let newColor;
  if (isRgb) {
    newColor = `rgb(${lightenedChannels.join(",")})`;
  } else {
    // Include the alpha channel for RGBA colors
    const alpha = channels[3];
    newColor = `rgba(${lightenedChannels.join(",")},${alpha})`;
  }

  return newColor;
};
export const convertRgbToRgba = (color, alpha) => {
  if (!color) {
    return color;
  }
  const rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+(\.\d+)?)\)$/;
  const rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;

  if (rgbaRegex.test(color)) {
    // If it's already in RGBA format, update the alpha value
    return color.replace(rgbaRegex, `rgba($1, $2, $3, ${alpha})`);
  } else if (rgbRegex.test(color)) {
    // If it's in RGB format, convert it to RGBA with the desired alpha
    const [, r, g, b] = color.match(rgbRegex);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } else if (color.startsWith("linear-gradient(")) {
    return addTransparencyToLinearGradient(color, alpha);
  } else {
    console.log("Invalid RGB or RGBA color format");
    return color;
  }
};
function addTransparencyToLinearGradient(linearGradient, alpha) {
  // Define a regular expression to match RGB components in the gradient
  const rgbRegex = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g;

  // Use a function as the replacement to add transparency to each RGB component
  const modifiedGradient = linearGradient.replace(
    rgbRegex,
    (match, r, g, b) => {
      // Calculate the new RGBA color
      const rgbaColor = `rgba(${r}, ${g}, ${b}, ${alpha})`;
      return rgbaColor;
    }
  );

  return modifiedGradient;
}
export function getContrastColor(background, color1, color2) {
  if (!background || !color1 || !color2) {
    return;
  }
  function getLuminance(color) {
    const rgb = color.match(/\d+/g);
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;

    const gammaCorrectedR =
      r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
    const gammaCorrectedG =
      g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
    const gammaCorrectedB =
      b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

    return (
      0.2126 * gammaCorrectedR +
      0.7152 * gammaCorrectedG +
      0.0722 * gammaCorrectedB
    );
  }

  const bgLuminance = getLuminance(background);
  const color1Luminance = getLuminance(color1);
  const color2Luminance = getLuminance(color2);

  const contrastWithColor1 = Math.abs(bgLuminance - color1Luminance);
  const contrastWithColor2 = Math.abs(bgLuminance - color2Luminance);

  if (contrastWithColor1 > contrastWithColor2) {
    return color1;
  } else {
    return color2;
  }
}
export function getContrastColorWithPriority(background, color1, color2) {
  if (!background || !color1 || !color2) {
    return;
  }
  const getRgbArray = (color) => {
    const rgb = color.match(/\d+/g);
    return rgb;
  };
  const getLuminanace = (values) => {
    const rgb = values.map((v) => {
      const val = v / 255;
      return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    return Number(
      (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)
    );
  };

  const getContrastRatio = (colorA, colorB) => {
    const lumA = getLuminanace(colorA);
    const lumB = getLuminanace(colorB);

    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
  };
  const color1Ratio = getContrastRatio(
    getRgbArray(background),
    getRgbArray(color1)
  );

  if (color1Ratio > 1.5) {
    return color1;
  } else {
    return color2;
  }
}
